import { useInfiniteQuery } from '@tanstack/react-query';

import useZDUser from '../useZDUser';

import { CommentsPage } from './useTicketComments.interface';
import fetchTicketComments from './useTicketComments.request';
import processComments from './processBotComments';

export default function useTicketComments(ticketId: number) {
    const { data: zdUser } = useZDUser();

    return useInfiniteQuery<CommentsPage, Error>({
        queryKey: ['ticketComments', ticketId],
        queryFn: async ({ pageParam }) => {
            const { comments, meta } = await fetchTicketComments(ticketId, pageParam as string);

            if (!meta?.has_more) {
                const { botMessage, comments: processedComments } = processComments(comments, zdUser);

                return {
                    botMessage,
                    comments: processedComments,
                    nextCursor: meta?.after_cursor,
                    hasMore: meta?.has_more ?? false,
                };
            }

            return {
                botMessage: null,
                comments,
                nextCursor: meta?.after_cursor,
                hasMore: meta?.has_more ?? false,
            };
        },
        initialPageParam: '',
        getNextPageParam: (lastPage) => (lastPage.hasMore ? lastPage.nextCursor : undefined),
        enabled: Boolean(ticketId && zdUser),
        staleTime: 1000 * 60 * 5,
        refetchInterval: 1000 * 60 * 5,
    });
}
